import $ from 'jquery';
import PlayList from './playlist';
import defaultConfigs from './default-configs';
import * as events from './events';

export default $.extend(PlayList, {
  events,
  create(configs) {
    return new PlayList($.extend({}, defaultConfigs, configs));
  }
});


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/core/video-playlist/index.js
 **/